import keys from 'lodash/keys';
import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';

import { getThemeValue } from './getTheme';
import type { Brand } from '../types/brand';

const getObjectWithVariants = (variantObj: any, theme: Brand) => {
  if (!isEmpty(variantObj) && 'variant' in variantObj) {
    const result = keys(variantObj).reduce<any>((previous, currentKey) => {
      const cssItem = variantObj[currentKey];

      if (currentKey === 'variant') {
        if (isString(cssItem)) {
          const variant = getObjectWithVariants(getThemeValue(theme, cssItem), theme);

          return { ...previous, ...variant };
        }

        return previous;
      }

      return {
        ...previous,
        [currentKey]: cssItem,
      };
    }, {});

    return result;
  }

  return variantObj;
};

export default getObjectWithVariants;
